module.exports = __webpack_public_path__ + "img/png.c02b91af.svg";